var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ip-location"},[_c('h1',[_vm._v("\n    IP: "+_vm._s(_vm.ipAddress)+"\n  ")]),_c('h1',[_vm._v("\n    定位: "+_vm._s(_vm.location)+"\n  ")]),_c('h1',[_vm._v("\n    请求响应: "+_vm._s(_vm.responseStr)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }